import React, { useState, useRef } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import classes from "../../../assets/styles/PageComponentsStyles/Function/ShowCustomURLSFunctions.module.css";
import DataTable, { createTheme } from "react-data-table-component";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import html2canvas from "html2canvas";
import { Image } from "react-bootstrap";
import cashapplogo from "../../../assets/images/function_page_icons/cashapplogo.svg";
import venmologo from "../../../assets/images/function_page_icons/venmologo.svg";
import paymentlogo from "../../../assets/images/function_page_icons/paymenticon.svg";
import { useAtom } from "jotai";
import { mobileViewCheck } from "../../../utils/store";
import ShareModal from "../../Modals/ShareModal";
import QRCodeModal from "../../Modals/QRCodeModal";
import Form from "react-bootstrap/Form";
import { trackEvent } from "../../../utils/mixpanel";

const ShowPaymentFunctions = ({
  show,
  handleShowModal,
  handleCloseModal,
  payments,
  handleDelete,
  handleStatus,
  getPayments,
  dynamicQRCodeId,
}) => {
  const target = useRef(null);

  const [showCopyPopup, setShowCopyPopup] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [mobileView] = useAtom(mobileViewCheck);

  const handleQrOpen = (obj) => {
    setSelectedData(obj);
    setQrOpen(true);
  };

  const handleQRClose = () => {
    setQrOpen(false);
    setShowCopyPopup(false);
    setSelectedData("");
  };

  const handleShareOpen = (obj) => {
    const searchParams = new URLSearchParams(window.location.search);

    const source = window.location.search.includes("dynamic_qr_code")
      ? "QR Code"
      : window.location.search.includes("team_id") &&
        window.location.search.includes("user_id")
      ? "Team Function"
      : "Function Page";

    const team_id = searchParams.get("team_id");
    const user_id = searchParams.get("user_id");
    const dynamic_qr_code = searchParams.get("dynamic_qr_code");

    trackEvent(`Share Action Initiated from ${source}`, {
      id: obj.id,
      title: obj.title || obj.name,
      function_type: obj.function_type,
      source,
      team_id,
      user_id,
      dynamic_qr_code,
      timestamp: new Date().toISOString(),
    });
    setSelectedData(obj);
    setShareOpen(true);
  };

  const handleShareClose = () => {
    setShareOpen(false);
    setShowCopyPopup(false);
    setSelectedData("");
  };

  const handleDownload = () => {
    html2canvas(document.querySelector("#qr-code")).then(function (canvas) {
      const link = document.createElement("a");
      link.download = "qrcode.png";
      link.href = canvas.toDataURL();
      link.click();
    });
  };

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Image",
      width: "10%",
      cell: (row) => (
        <div className={classes.titleWrapper}>
          {row.payment_type === "cash_app" ? (
            <Image
              src={cashapplogo}
              width="50px"
              height="50px"
              // roundedCircle={true}
              style={{ borderRadius: "8px" }}
            />
          ) : row.payment_type === "venmo" ? (
            <Image
              src={venmologo}
              width="50px"
              height="50px"
              // roundedCircle={true}
              style={{ borderRadius: "8px" }}
            />
          ) : (
            <div
              style={{
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // border: "5px solid var(--primary_text_color)",
                borderRadius: "50%",
                background: "var(--blue-color)",
              }}
            >
              <Image
                src={paymentlogo}
                width="30px"
                height="30px"
                // roundedCircle={false}
                style={{ borderRadius: "8px" }}
              />
            </div>
          )}
        </div>
      ),
    },
    {
      name: "Title",
      width: "20%",
      cell: (row) => <p className="globalTitle">{row.title}</p>,
    },

    {
      name: "Payment Service Type",
      width: "20%",
      cell: (row) => (
        <div className="profileWrapper">
          <p className="globalDetail">
            {row.payment_type === "cash_app"
              ? "cash app"
              : row.payment_type === "custom_payment"
              ? "other"
              : row.payment_type}
          </p>
        </div>
      ),
    },
    {
      name: "URL Path",
      width: "30%",
      cell: (row) => (
        <a
          href={row.url_path}
          target="_blank"
          className={"globalUrlPath"}
          style={{ display: "block" }}
          rel="noreferrer"
        >
          {row.url_path}
        </a>
      ),
    },
    {
      name: "Status",
      width: "10%",
      center: "true",
      cell: (row) =>
        row.is_expired === 1 ? (
          <Form.Check
            type="switch"
            checked={row.status}
            onClick={() => handleStatus(row.id, row.payment_type)}
            disabled
          />
        ) : (
          <Form.Check
            type="switch"
            checked={row.status}
            onClick={() => handleStatus(row.id, row.payment_type)}
          />
        ),
    },
    {
      name: "Action",
      right: "true",
      cell: (row) => (
        <div className={classes.action}>
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          {row.is_expired === 1 ? (
            <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
              <li>
                <span
                  className="dropdown-item"
                  to="#"
                  style={{ color: "var(--error_color)", cursor: "pointer" }}
                  onClick={() => handleDelete(row.id)}
                >
                  Delete
                </span>
              </li>
            </ul>
          ) : (
            <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
              <li>
                <a
                  className="dropdown-item"
                  href={row.url_path}
                  target="_blank"
                  rel="noreferrer"
                >
                  Visit Link
                </a>
              </li>
              <li>
                <span
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleShowModal(row)}
                >
                  Edit
                </span>
              </li>
              <li>
                <span
                  className="dropdown-item"
                  onClick={() => {
                    handleStatus(row.id, row.payment_type);
                  }}
                >
                  {row.status ? "Inactive" : "Active"}
                </span>
              </li>
              {dynamicQRCodeId !== null ? (
                ""
              ) : (
                <>
                  <li>
                    <span
                      className="dropdown-item"
                      onClick={() => handleQrOpen(row)}
                    >
                      QR Code
                    </span>
                  </li>
                  <li>
                    <span
                      className="dropdown-item"
                      onClick={() => handleShareOpen(row)}
                    >
                      Share
                    </span>
                  </li>
                </>
              )}
              <li>
                <span
                  className="dropdown-item"
                  // style={{ color: "var(--error_color)", cursor: "pointer" }}
                  onClick={() => {
                    handleDelete(row.id);
                  }}
                >
                  Delete
                </span>
              </li>
            </ul>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="default-list-table">
        <DataTable columns={columns} data={payments} theme="solarized" />
      </div>
      {qrOpen && (
        <QRCodeModal
          qrOpen={qrOpen}
          target={target}
          handleQRClose={handleQRClose}
          setShowCopyPopup={setShowCopyPopup}
          handleDownload={handleDownload}
          functionType={
            selectedData.payment_type === "custom_payment"
              ? "customPayment"
              : selectedData.payment_type === "cash_app"
              ? "cashApp"
              : selectedData.payment_type
          }
          functionUuid={selectedData.uuid}
          selectedData={selectedData}
          id={selectedData.id}
          function_type={selectedData.function_type}
          functionId={selectedData.id}
          QRCodeCustomize={selectedData.qrCodeCustomize}
          refreshData={getPayments}
        />
      )}

      {shareOpen && (
        <ShareModal
          target={target}
          shareOpen={shareOpen}
          handleShareClose={handleShareClose}
          setShowCopyPopup={setShowCopyPopup}
          functionType={
            selectedData.payment_type === "custom_payment"
              ? "customPayment"
              : selectedData.payment_type === "cash_app"
              ? "cashApp"
              : selectedData.payment_type
          }
          functionUuid={selectedData.uuid}
        />
      )}

      <Overlay
        target={target.current}
        show={showCopyPopup}
        placement={mobileView ? "left" : "right"}
      >
        {(props) => (
          <Tooltip id="overlay-example" {...props}>
            Link Copied
          </Tooltip>
        )}
      </Overlay>
      <style type="">
        {`
          .form-switch{
            padding-left: 2.52rem;
          }
        `}
      </style>
    </>
  );
};

export default ShowPaymentFunctions;
